import React, { useState, useEffect, useRef } from 'react';
import TauriVisualFactory from '../TauriVisualFactory/TauriVisualFactory';
import { useFilterContext } from '../TauriGlobalContext/TauriGlobalContext';
import config from '../../appURL.json';
import './TauriSectionBaseVisual.css';

const TauriSectionBaseVisual = ({ visual, columnSize, rowSize, palettes, themes, isModal }) => {
  const [chartData, setChartData] = useState();
  const [isLoading, setIsLoading] = useState();
  const { filterValue } = useFilterContext();

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('token');
      const accesscode = localStorage.getItem('accesscode');
      const code = localStorage.getItem('code');
      const fromMonth = localStorage.getItem('FromMonth');
      const toMonth = localStorage.getItem('ToMonth');
      const fromYear = localStorage.getItem('FromYear');
      const toYear = localStorage.getItem('ToYear');
      const configType = localStorage.getItem('ConfigTypeCode');

      setIsLoading(true);

      const filterData = {
        FromMonth: fromMonth?.toString(),
        FromYear: fromYear?.toString(),
        ToMonth: toMonth?.toString(),
        ToYear: toYear?.toString(),
        [code || '']: accesscode?.toString(),
        ConfigTypeCode: configType?.toString()
      };

      const filter = accesscode ? filterData : filterValue
      const parameters = updateParameters(visual.binding.data.parameters, filter);
      const requestBody = {
        "id": visual.binding.data.endpoint,
        "params": parameters
      };

      try {
        const response = await fetch(config.API_GetData, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          console.error('Failed to fetch data:', response.status);
          setChartData([]);
          return;
        }

        const data = await response.json();
        setChartData(JSON.parse(data.result.data));
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false); // Set isLoading to false when API call completes
      }
    };

    const fetchDataWithDelay = () => {
      setTimeout(fetchData, 300);
    };

    fetchDataWithDelay();
  }, [visual, filterValue]);

  const updateParameters = (parameters, dataFilter) => {
    const updatedParameters = [...parameters];

    updatedParameters.forEach((param) => {

      if (dataFilter.hasOwnProperty(param.key) && dataFilter[param.key] !== null && dataFilter[param.key] !== undefined) {
        param.value = dataFilter[param.key];
      }
    });
    return updatedParameters;
  }

  const getPalettes = (ranges) => {
    const foundPalettes = [];
    for (const range of ranges) {
      const palette = palettes.find(palette => palette.id === range);
      if (palette) {
        foundPalettes.push(palette);
      }
    }
    return foundPalettes;
  };

  const getTheme = (themeID, type) => {
    const theme = themes.find(theme => theme.id === themeID); // Find the theme by ID
    if (theme) {
      const chart = theme.charts.find(chart => chart.type === type);
      if (chart) {
        return getPalettes(chart.ranges);
      }
    }
    return [];
  };

  const chartPalettes = getTheme(visual.colorTheme, visual.type);

  return (
    <div>
      {!isModal && <div className="chart-title">{visual.title}</div>}
      {isLoading ? (
        <div className="loader-container">
          <div class="loader-basevisual"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>

      ) : (
        <>
          {!chartData || !chartData?.[0] ? (
            <div className="no-records-container">There are no records to display</div>
          ) : (
            TauriVisualFactory(visual, chartData, chartPalettes, columnSize, rowSize, palettes, themes)
          )}
        </>
      )}
    </div>
  );
};

export default TauriSectionBaseVisual;
